import React from "react";
import styles from "./../../../../assets/scss/custom.module.scss";
import CustomerEventLog from "../../../../components/table/all-tables/CustomerEventLog";
import { customerTab } from "../../../../locales/en";

const CustomerLog = () => {
  return (
    <>
      <div className={styles.titleArea}>
        <h5>{customerTab?.customerLog.title}</h5>
      </div>
      <div className="row">
        <div className="col-12 mb-3">
          <CustomerEventLog />
        </div>
      </div>
    </>
  );
};

export default CustomerLog;
